export const ADD_TO_TASKS_QUEUE = "ADD_TO_TASKS_QUEUE";
export const CHANGE_TASK_SUCCESS = "CHANGE_TASK_SUCCESS";
export const CHANGE_TASK_FAILURE = "CHANGE_TASK_FAILURE";
export const CHANGE_TASK_DISPLAY_STATUS = "CHANGE_TASK_DISPLAY_STATUS";
